<!-- Collocation Grouper allows the user to assign collocations to groups. For a given
lemma, pattern and position of lemma in pattern:
- fetches the collocations from server
- displays groups
- displays not-grouped colls (with sort + filter?)
- displays dump (wrong collocations)
...

Findings:
- *Options to sortable.js* need to be passed via the options property, using the options as properties
  does not work (e.g. handle, group).
- *Using v-model with input* gets the data updated on every input event, which moves away the focus (in Firefox)
  Workaround: bind to update.
- Handle
-->
<template>
  <div class="row-fill container-row">
    <div class="col-fill container-col">
      <h1 class="row-fit">
          <router-link :to="'/' + lempos">{{lemma}}</router-link>
        <span class="subtitle"> تصنيف المتواردات اللفظية على شكل {{pattern}} </span>
      </h1>
      <draggable v-model="semanticGroups" draggable=".draggable-group" class="col-fill container-col-wrapped">
        <!-- header-slot: "most frequent unrated" and "correct ungrouped" collocations -->
        <div slot="header">
          <div  class="group">
            <input readonly value="unrated"/>
            <div>
              <collocation v-for="lempos in mostFrequentUnrated" :key="lempos" :lempos-string="lempos"
                          :pattern="pattern" :core-indexes="coreIndexes" :show-core="false" linkTarget="grouping" class="collocation"/>
            </div>
          </div>
          <div  class="group">
            <input readonly value="ungrouped"/>
            <draggable v-model="correctUngrouped" group="colls" draggable=".draggable-item" class="min-height" slot="header">
              <collocation v-for="lempos in correctUngrouped" :key="lempos" :lempos-string="lempos"
                          :pattern="pattern" :core-indexes="coreIndexes" :show-core="false" linkTarget="grouping" class="collocation draggable-item"/>
            </draggable>
          </div>        </div>
        <!-- main-slot: semantic groups -->
        <draggable-semantic-group v-for="g in semanticGroups" :key="g.id"
                            :value="g" @input="updateSemanticGroup(g.id, $event)" @delete="deleteSemanticGroup(g.id)"
                            :pattern="pattern" :core-indexes="coreIndexes"
                            class="group draggable-group"/>
        <!-- footer-slot: add group button and json-view -->
        <template slot="footer">
          <button @click="addSemanticGroup">add group</button>
          <!-- <pre style="direction: ltr; text-align: left">{{groups}}</pre> -->
        </template>
      </draggable>
    </div>
    <collocation-details v-if="collLempos" :lempos="collLempos" :pattern="pattern" class="col-fit side-pane"/>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import DraggableSemanticGroup from '../components/DraggableSemanticGroup.vue'
import CollocationDetails from '../components/CollocationDetails.vue'
import Collocation from '../components/Collocation.vue'

export default {
  name: 'GroupingView',
  props: {
    lempos: String,
    pattern: String,
    coreIndexes: Array,
    collLempos: String,
    draggableGroup: String
  },
  components: {
    DraggableSemanticGroup,
    CollocationDetails,
    draggable,
    Collocation
  },
  created: function () {
    this.$store.dispatch('loadGroups', { lempos: this.lempos })
  },
  computed: {
    groups: function () {
      return this.$store.getters.getGroupsForQualifiedPattern(this.lempos, this.pattern, this.coreIndexes)
    },
    mostFrequentUnrated: function () {
      return this.groups ? this.groups.unrated_by_freq.slice(0, this.$store.state.topnMinSize) : []
    },
    semanticGroups: {
      get () {
        return this.groups ? this.groups.semantic_groups : []
      },
      set (value) {
        this.$store.dispatch('updateSemanticGroups',
          { lempos: this.lempos, pattern: this.pattern, coreIndexes: this.coreIndexes, groups: value })
      }
    },
    correctUngrouped: {
      get () {
        return this.groups ? this.groups.correct_ungrouped : []
      },
      set (value) {
        this.$store.commit('updateCorrectUngrouped',
          { lempos: this.lempos, pattern: this.pattern, coreIndexes: this.coreIndexes, colls: value })
      }
    },
    lemma: function () { return this.lempos.split('+')[0] }
  },
  methods: {
    updateSemanticGroup: function (id, g) {
      const idx = this.semanticGroups.findIndex(g => g.id === id)
      console.log('Update semantic group', this.semanticGroups[idx], 'at index ' + idx + ' of', this.semanticGroups, 'with', g)
      // This is indeed confusind. Maybe emit an event directly instead of letter the setter do it
      this.semanticGroups = [...this.semanticGroups.slice(0, idx), g, ...this.semanticGroups.slice(idx + 1)]
    },
    deleteSemanticGroup: function (id) {
      const idx = this.semanticGroups.findIndex(g => g.id === id)
      console.log('Deleting semantic group', this.semanticGroups[idx], 'at index ' + idx + ' of', this.semanticGroups)
      // This is indeed confusing. Maybe emit an event directly instead of letter the setter do it
      this.correctUngrouped = [...this.correctUngrouped, ...this.semanticGroups[idx].collocations]
      this.semanticGroups = [...this.semanticGroups.slice(0, idx), ...this.semanticGroups.slice(idx + 1)]
    },
    addSemanticGroup: function () {
      this.$store.commit('addSemanticGroup', { semanticGroups: this.semanticGroups })
    },
    log: function (msg) { console.log(msg) }
  }
}
</script>

<style scoped>
input {
  width: 90%;
}
div.collocation {
  background-color: lightgray
}

.group {
    background-color:antiquewhite;
    border: 1px solid black;
    padding: 5px;
    display: flex;
    flex-direction: column;
    margin: 20px;
    width: 200px;
}

.min-height {
  min-height: 20px;
}
</style>
